import { Routes } from '@angular/router';

import { home } from './pages/home/home.routes';
import { login } from './pages/login/login.routes';
import { lockscreen } from './pages/lockscreen/lockscreen.routes';
import { app } from './pages/app/app.routes';
import { user } from './pages/user/user.routes';
import { registroCivil } from './pages/registro-civil/registro-civil.routes';
import { sat } from './pages/sat/sat.routes';
import { antecedente } from './pages/antecedente/antecedente.routes';
import { setting } from './pages/setting/setting.routes';
import { report } from './pages/report/report.routes';
import { imss } from './pages/imss/imss.routes';
import { renapo } from '@pages/renapo/renapo.routes';
import { issste } from '@pages/issste/issste.routes';
import { cfe } from '@pages/cfe/cfe.routes';

export const routes: Routes = [
  ...home,
  ...login,
  ...lockscreen,
  ...app,
  ...user,
  ...registroCivil,
  ...sat,
  ...antecedente,
  ...setting,
  ...report,
  ...imss,
  ...renapo,
  ...issste,
  ...cfe,
  {
    path: '**',
    redirectTo: 'home',
    pathMatch: 'full',
  },
];
